
const img_url = process.env.VUE_APP_API_URL + 'upload/'
const base_url = process.env.VUE_APP_API_URL
export default { img_url, base_url }

